export class User{
    public nomina: number
    public nombre: string
    public dateLogIn: number
    public permissions: any 
    public perfil?:any
}